// Vendors
import $ from 'jquery';

$(document).ready(() => {
  const { endpoint, nonce } = window.uConfig;
  const $form = { join: $('#join-form') };
  const $formBtn = { join: $('#join-form__submit') };
  let formData = {};

  // Form event listeners.
  $(document)
    .on('click', '#join-form__submit', (event) => processRegisterUser(event))
    .on('submit', '#join-form', (event) => processRegisterUser(event));

  // pre-submit error handling
  onBlurHandleError($('*[required]'));

  // form submit
  function processRegisterUser(event) {
    event.preventDefault();

    const method = $(event.currentTarget).data('method');

    $('*[required]').each(function () {
      checkFields($(this));
    });

    if ($('#join-form .form__field--error').length > 0) {
      $('html').animate(
        {
          scrollTop: $('#join-form .form__field--error').offset().top - 75
        },
        1000
      );
      return;
    }

    // Check what fields actually have updated values, compared to `usermeta`.
    formData = Object.values($form[method].serializeArray()).reduce(
      (acc, current) => {
        return {
          ...acc,
          [current['name']]: current['value']
        };
      },
      {}
    );

    // No call necessary if no values changed.
    if (!Object.keys(formData).length) {
      return;
    }

    $formBtn[method].attr('disabled', 'disabled');
    $form[method].addClass('form--loading');

    $('html').animate(
      {
        scrollTop: $('#join-form').offset().top - 75
      },
      1000
    );

    setTimeout(() => {
      makeAjaxCall(formData, method);
    }, 2500);
  }

  function makeAjaxCall(data, method) {
    $.ajax({
      url: endpoint,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'wl_register_user',
        method,
        nonce,
        ...data
      },
      success: ({ success, data: { error, updated, method, message } }) => {
        // Only happens with invalid nonce or invalid user id:
        if (!success) {
          $form['join'].prepend(
            `<div class="grid__col-xs-12">
                <div class="notice notice--red">
                  <div class="notice__type">
                    <strong class="notice__title">Error</strong>
                  </div>
                  <div class="notice__message">
                    <div class="u--text-align-center-md-max">That email address is already associated with an account. You can <a href="/my-account">log in</a> or try again with a new email address.</div>
                  </div>
                </div>
              </div>
            `
          );

          $formBtn[method].removeAttr('disabled');
          $form[method].removeClass('form--loading');
          return;
        }

        // Remove notices.
        $form['join'].find('.notice').remove();

        // If applicable, update usermeta variable and write/display notices.
        if (updated.length) {
          writeNotice($form['join'], updated);
          $form[method].removeClass('form--loading');

          setTimeout(() => {
            window.location = '/my-coop';
          }, 3000);
        }

        // If applicable, write errors and toggle error classes.
        if (Object.keys(error).length) {
          Object.keys(error).map((inputField, index) => {
            $(`#${inputField}`).next('.form__help').text(error[inputField]);
            $(`#${inputField}`)
              .parents('.form__field')
              .addClass('form__field--error');
          });
        }
      },
      error: function () {
        $form['join'].prepend(
          `<div class="grid__col-xs-12">
                <div class="notice notice--red">
                  <div class="notice__type">
                    <strong class="notice__title">Error</strong>
                  </div>
                  <div class="notice__message">
                    <div class="u--text-align-center-md-max">There was an issue, please try again.</div>
                  </div>
                </div>
              </div>
            `
        );

        $formBtn[method].removeAttr('disabled');
        $form[method].removeClass('form--loading');
        return;
      }
    });
  }

  function writeNotice($formElement, updatedFields) {
    // Write and append notice.
    $formElement.prepend(
      `<div class="grid__col-xs-12">
        <div class="notice notice--green">
          <div class="notice__type"> <strong class="notice__title">Success</strong></div><div class="notice__message">
          <div class="u--text-align-center-md-max">Your profile has been created. If you are not redirected automatically, visit <a href="/my-account">My Account</a> and log in.</div>
        </div>
      </div>`
    );
  }

  // error handling
  function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function isError(el, name) {
    el.next('.form__help').text(`${name} is required`);
    el.parents('.form__field').addClass('form__field--error');
    if (name === 'terms') {
      el.parents('.form__field').addClass('validation-error');
    }

    return false;
  }

  function isErrorEmail(el, name) {
    el.next('.form__help').text(`${name} must be valid`);
    el.parents('.form__field').addClass('form__field--error');
    return false;
  }

  function isValid(el) {
    el.next('.form__help').text('');
    el.parents('.form__field').removeClass('form__field--error');
  }

  function passMatch() {
    const $pass1 = $('#pass1');
    const $pass2 = $('#pass2');

    if ($pass1.val() !== '' && $pass2.val() !== '') {
      if ($pass1.val() === $pass2.val()) {
        $pass2.next('.form__help').text('');
        $pass2.parents('.form__field').removeClass('form__field--error');
      } else {
        $pass2.next('.form__help').text('Password does not match.');
        $pass2.parents('.form__field').addClass('form__field--error');
        return false;
      }
    } else {
      $pass2.next('.form__help').text('Password does not match.');
      $pass2.parents('.form__field').addClass('form__field--error');
      return false;
    }
  }

  function checkFields(el) {
    const name = el.prev('.form__label').text().slice(0, -1);
    const $id = el.attr('id');
    const $val = el.val();

    if ($val === '') {
      isError(el, name);
    } else if ($id === 'email') {
      if (emailIsValid($val) == false) {
        isErrorEmail(el, name);
      } else {
        isValid(el);
      }
    } else if ($id === 'pass2') {
      passMatch();
    } else {
      isValid(el);
    }

    if ($id === 'terms') {
      const isChecked = el.is(':checked');
      if (!isChecked) {
        isError(el, 'terms');
      } else {
        isValid(el);
      }
    }
  }

  function onBlurHandleError(requiredEls) {
    requiredEls.each(function () {
      $(this).on('blur', function () {
        checkFields($(this));
      });
    });
  }
});
